// extracted by mini-css-extract-plugin
module.exports = {"table-container":"OrderHistory_table-container__Jd_Ma","table":"OrderHistory_table__3XGVe"};